module.exports = __webpack_public_path__ + "img/wiperx_04.527782ba.jpg";